import React, { useState } from "react";
import { file2Base64 } from "@pankod/refine-core";

import {
  Form,
  Input,
  Select,
  useSelect,
  Radio,
  Modal,
  ModalProps,
  FormProps,
  Upload,
  Row,
  Col,
  Icons,
  getValueFromEvent,
} from "@pankod/refine-antd";

import { Tags } from "interfaces";

type Props = {
  modalProps: ModalProps;
  formProps: FormProps;
};

export const AssetsCreate: React.FC<Props> = ({ formProps, modalProps }) => {
  const [base64Image, setBase64Image] = useState<string | undefined>();

  const renderDraggerContent = () => {
    if (base64Image) {
      return <img src={base64Image} width="100%" alt="" />;
    }

    return (
      <div style={{ marginBottom: "112px", marginTop: "112px" }}>
        <p className="ant-upload-drag-icon">
          <Icons.InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Yüklemek için dosyayı bu alana tıklayın veya sürükleyin
        </p>
      </div>
    );
  };

  const onChange = async ({ fileList: newFileList }) => {
    const base64String = await file2Base64(newFileList[0]);
    setBase64Image(base64String);
  };

  const { selectProps: tagsFilterSelectProps } = useSelect<Tags.TagItem>({
    resource: "tags",
    optionLabel: "name",
    optionValue: "id",
  });

  const requestCreate = async (values: any) => {
    const { image } = values;

    let base64String;
    for (const file of image) {
      if (file.originFileObj) {
        base64String = await file2Base64(file);
      }
    }

    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        image: base64String,
      })
    );
  };

  return (
    <Modal
      {...modalProps}
      width={800}
      title="Ürün Ekle"
      okText="Kaydet ve Kapat"
    >
      <Form
        {...formProps}
        initialValues={{ isActive: true }}
        onFinish={requestCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item>
              <Form.Item
                name="image"
                valuePropName="fileList"
                getValueFromEvent={getValueFromEvent}
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Dosya görseli boş olamaz.",
                  },
                ]}
              >
                <Upload.Dragger
                  accept=".png"
                  beforeUpload={() => false}
                  multiple={false}
                  maxCount={1}
                  onChange={onChange}
                  showUploadList={false}
                >
                  {renderDraggerContent()}
                </Upload.Dragger>
              </Form.Item>
            </Form.Item>
            <span
              style={{
                fontSize: "12px",
                color: "#8C8C8C",
                fontWeight: 300,
                letterSpacing: "0.5px",
              }}
            >
              min
              <strong> 1080x1080 </strong>
              transparan
              <strong> .png </strong>
              olmalı
            </span>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Dosya İsmi"
              name="name"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: "Dosya ismi alanı boş olamaz.",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Durumu"
              name="isActive"
              rules={[
                {
                  required: true,
                  message: "Dosya durumunu seçiniz.",
                },
              ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Aktif",
                    value: true,
                  },
                  {
                    label: "Pasif",
                    value: false,
                  },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Etiketler"
              name="tags"
              rules={[
                {
                  required: true,
                  message: "Dosya için tag seçiniz.",
                },
              ]}
              getValueProps={(tags?: { id: string }[]) => {
                return { value: tags?.map((store) => store.id) };
              }}
              getValueFromEvent={(args: string[]) => {
                return args.map((item) => ({
                  id: item,
                }));
              }}
            >
              <Select
                {...tagsFilterSelectProps}
                style={{ width: "100%" }}
                mode="multiple"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
